"use strict";

exports.__esModule = true;
exports.PORTAL_WRAPPER_ATTR_NAME = exports.PORTAL_EXIT_ATTR_NAME = void 0;
var PORTAL_EXIT_ATTR_NAME = 'data-tds-portal-exit';
exports.PORTAL_EXIT_ATTR_NAME = PORTAL_EXIT_ATTR_NAME;
var PORTAL_WRAPPER_ATTR_NAME = 'data-tds-portal-wrapper';
exports.PORTAL_WRAPPER_ATTR_NAME = PORTAL_WRAPPER_ATTR_NAME;